var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-search',{ref:"search",on:{"clear":function($event){return _vm.clear()},"search":function($event){return _vm.search()}},model:{value:(_vm.query),callback:function ($$v) {_vm.query=$$v},expression:"query"}})
}
var staticRenderFns = []

export { render, staticRenderFns }